module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4ef9378078d331db8fa055d21aee5e5b.gif";